import "./ClientDashboardMobileComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit, IScope} from "angular";
import {ClientDashboardModel} from "../models/ClientDashboardModel";
import {UserNotificationPreferencesService} from "../../../notifications/services/preferences/UserNotificationPreferencesService";
import {ReplaySubject} from "rxjs";
import {NotificationState} from "../../../notifications/services/preferences/models/NotificationState";
import {MessageType} from "../../../notifications/services/preferences/models/MessageType";
import {WatchListStore} from "../../../watchlist/store/WatchListStore";
import {LocalStorageService} from "../../../types/NgStorage";
import {WatchlistId} from "../../../watchlist/models/WatchlistId";
import {isNotNull} from "../../../js/util/UtilFunctions";

export const ClientDashboardMobile = "tfClientDashboardMobile";

type ViewNames = "portfolio" | "alerts" | "watchlist" | "systems";

interface DashboardStateParams {
    view?: ViewNames | null;
}

export function clientDashboardMobile(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/mobile/ClientDashboardMobileComponent.html`,
        bindings: {
            model: "<"
        },
        controllerAs: "ctrl",
        controller: ClientDashboardMobileComponentController
    };
}
const PreviousWatchlistStorageKey = "clientDashboardSelectedWatchlist";

export class ClientDashboardMobileComponentController implements IOnInit, IOnDestroy {

    public readonly model: ClientDashboardModel;
    public readonly selectedWatchlist$ = new ReplaySubject<WatchlistId | null>(1);
    public activeTab: ViewNames = "portfolio";
    public showNotificationToggle = false;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly $scope: IScope,
                       private readonly $stateParams: DashboardStateParams,
                       private readonly userNotificationPreferencesService: UserNotificationPreferencesService,
                       private readonly watchListStore: WatchListStore,
                       private readonly $localStorage: LocalStorageService) {
    }

    public $onInit() {
        this.setDefaultTab();
        this.watchNotificationPrefs();
        this.watchWatchlistSelection();
    }

    private watchWatchlistSelection() {

        const previouslySelected = this.$localStorage[PreviousWatchlistStorageKey];
        if (previouslySelected != null) {
            this.selectedWatchlist$.next(previouslySelected);
        }

        this.watchListStore
            .defaultWatchlist
            .filter(isNotNull)
            .first()
            .takeUntil(this.selectedWatchlist$) // If we get another selection then stop trying to get a default
            .map((wl) => wl.id)
            .subscribe((id) => this.selectedWatchlist$.next(id));
    }

    public watchlistSelectionChanged(id: WatchlistId) {
        this.selectedWatchlist$.next(id);
        this.$localStorage[PreviousWatchlistStorageKey] = id;
    }

    private setDefaultTab() {
        if (this.$stateParams.view != null) {
            this.activeTab = this.$stateParams.view;
        }
    }

    private watchNotificationPrefs() {
        // TODO move this into a directive that hides the element based on the enabled notification preference
        this.userNotificationPreferencesService
            .preferences
            .takeUntil(this.destroyed$)
            .map((pref) => pref.state(MessageType.TRADE_IDEA))
            .map((state) => state === NotificationState.ACTIVE)
            .subscribe((enabled) => {
                this.$scope.$applyAsync(() => this.showNotificationToggle = !enabled);
            });
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
